module.exports = __webpack_public_path__ + "static/img/2011-B.8ddecf4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2011-B.png
// module id = kZ7X
// module chunks = 1